import Banner from "../components/Resource/Banner";
import Section from "../components/Resource/Section";
const ResourcesPage = () => {
  return (
    <>
      <Banner />
      <Section />
    </>
  );
};

export default ResourcesPage;
